import axios from "axios";
import { AttemptsPayload, ClaimsTypesPayload, DeleteAttempsPayload } from "../../types";
import { MAIN_URL, QueueEndpoints, Subdomains } from "../../constants";
import { IAttempt } from "../../types/images";

axios.defaults.withCredentials = true;

export async function getClaimsTypeAPI(queueType: string) {
  return await axios<ClaimsTypesPayload>({
    method: "GET",
    url: `${MAIN_URL}${Subdomains.queue}${QueueEndpoints.getClaimsTypes}/${queueType}`,
  });
}

export async function getCaseForReviewAPI(args: {
  queueType: string;
  claimType: string;
  userInfoId: number | null;
  regNum: number | null;
}) {
  const { queueType, claimType, userInfoId, regNum } = args;
  return await axios<AttemptsPayload>({
    method: "GET",
    url: `${MAIN_URL}${Subdomains.queue}${QueueEndpoints.getAttemptsForReview}/${queueType}/${claimType}/${userInfoId}/${regNum}`,
  });
}

export async function cleanUnderReviewAPI() {
  return await axios<DeleteAttempsPayload>({
    method: "GET",
    url: `${MAIN_URL}${Subdomains.queue}${QueueEndpoints.cleanUnderReview}`,
  });
}

export async function submitDecisionAPI(args: {
  queueType: string;
  attempts: IAttempt[];
  decision: string;
  reason: string;
  varification: boolean;
  comment: string | null;
}) {
  const { queueType, attempts, decision, reason, varification, comment } = args;
  return await axios<AttemptsPayload>({
    method: "POST",
    url: `${MAIN_URL}${Subdomains.queue}${QueueEndpoints.decision}/${
      queueType === "survivors_portal" ? "SP" : queueType
    }`,
    data: { attempts, decision, reason, varification, comment },
  });
}
